// extracted by mini-css-extract-plugin
module.exports =  {"marginBuster":"ZDA65fpfhmGFnDcadtzS"};